export default "__VITE_ASSET__D$Z$GWl2__"